<li class='films__item' data-id={{id}}>
  <div class='films__img'>
    <img
      src='{{poster_path}}'
      alt={{original_title}}
      loading='lazy'
    />
  </div>
  <div class='films__description'>
    <p class='films__name'>{{title}}</p>
    <p class='films__info'>{{genre_ids}} | {{release_date}}</p>        
      <svg class="films__fav-icon" xmlns="http://www.w3.org/2000/svg" height="48" width="48">
        <path
          d="m24 41.95-2.05-1.85q-5.3-4.85-8.75-8.375-3.45-3.525-5.5-6.3T4.825 20.4Q4 18.15 4 15.85q0-4.5 3.025-7.525Q10.05 5.3 14.5 5.3q2.85 0 5.275 1.35Q22.2 8 24 10.55q2.1-2.7 4.45-3.975T33.5 5.3q4.45 0 7.475 3.025Q44 11.35 44 15.85q0 2.3-.825 4.55T40.3 25.425q-2.05 2.775-5.5 6.3T26.05 40.1Z" />
      </svg>    
  </div>
</li>